<template>
	<page>
		<title-view>
			ניהול ארגונים
			<v-btn
				slot="actions"
				btn
				@click="onEdit({})"
			>
				הוספת ארגון
			</v-btn>
		</title-view>
		<row>
			<c-col>
				<organizations-table @edit="onEdit" />
			</c-col>
		</row>
		<popup-dialog v-model="openModal">
			<span slot="header">יצירת/עריכת Organization</span>
			<organization-form
				v-if="openModal"
				@save="openModal=false"
			/></organization-form>
		</popup-dialog>
	</page>
</template>

<script>
import OrganizationForm from "src/view/organizations/OrganizationForm";
import OrganizationsTable from "src/view/organizations/OrganizationsTable";
import { types } from "dev/store/modules/Organization.module";

export default {
	name: "OrganizationsView",
	components: { OrganizationsTable, OrganizationForm },
	data () {
		return {
			openModal: false,
		};
	},
	methods: {
		onEdit (organization) {
			if (organization.id) {
				this.$store.commit(types.GET, organization);
			} else {
				this.$store.commit(types.CREATE, organization);
			}
			this.openModal = true;
		},
	},

};
</script>

<style scoped>

</style>
